/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Tracking_Datapoints_Action2Inputs */

const en_coinvestments_tracking_datapoints_action2 = /** @type {(inputs: Coinvestments_Tracking_Datapoints_Action2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update Salesforce Data`)
};

/**
* | output |
* | --- |
* | "Update Salesforce Data" |
*
* @param {Coinvestments_Tracking_Datapoints_Action2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_tracking_datapoints_action2 = /** @type {((inputs?: Coinvestments_Tracking_Datapoints_Action2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Tracking_Datapoints_Action2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_tracking_datapoints_action2(inputs)
});
export { coinvestments_tracking_datapoints_action2 as "coInvestments_tracking_dataPoints_action" }